import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import type { Checklist } from "models";

export const useShowPendingChecklistsNotifications = () => {
  const { t } = useTranslation();

  return {
    showPendingChecklistsNotifications: (added_checklists?: Checklist[], not_added_checklists?: Checklist[]) => {
      added_checklists?.forEach(checklist => {
        toast.success(
          t("v8_checklist_ChecklistName_is_now_pending_on_this_intervention", "Checklist {{checklistName}} is now pending on this intervention", {
            checklistName: checklist.name
          })
        );
      });

      not_added_checklists?.forEach(checklist => {
        toast.error(
          t("v8_checklist_ChecklistName_cannot_be_added_as_pending_on_this_intervention", "Checklist {{checklistName}} cannot be added as pending on this intervention", {
            checklistName: checklist.name
          })
        );
      });
    }
  };
};
